export const FeatureFlags = {
  PERSPECTIVES_AI: 'fe.is-perspectives-ai-enabled',
  POSTHOG_CORE: 'posthog-core',
  DATADOG_RUM: 'datadog-rum',
  DATADOG_LOGS: 'datadog-logs-fe',
  EDITABLE_CUSTOM_ACCESS_CODE: 'editable-custom-access-code',
  MERGE_API: 'fe.merge-api',
  MULTIPLE_ONBOARD_SURVEYS: 'multiple-onboard-surveys',
  CONFIGURABLE_ONBOARD_DISTRIBUTION: 'fe.admin-ui.configurable-onboard-distribution',
  HEADLINES_ENABLED: 'fe.headlines-enabled',
  ACT_ENABLED: 'fe.action-planning',
  POSSIBLE_LEAVERS_HRIS: 'fe.possible-leavers-hris-detection',
  INTERCOM: 'fe.enable-intercom',
  LINK_RESET_DIGEST: 'fe.admin-ui.link-reset-digest',
  TEMPLATE_LIBRARY_UPLOAD: 'template-library-upload',
  FLEXIBLE_SURVEY_CREATION: 'flexible-survey-creation',
  PULSE_SURVEY_RENAME: 'fe.admin-ui.pulse-survey-rename',
  ACTIVE_SESSIONS: 'fe.active-sessions',
  GLOBAL_QUESTION_LIBRARY: 'global-question-library',
} as const;
